import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { uiStore } from 'shared/store/uiStore'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'
import { SuccessActivatedModalUi } from 'pages/chatbot/pages/calling/actions/showSuccessActivatedModal/ui/SuccessActivatedModalUi'

export const showSuccessActivatedModal = (): void => {
  const id = nanoid()
  modalStore.addModal({
    id,
    type: ModalTypeList.DEFAULT,
    disabledOnAllClose: true,
    closeActionButtonProps: {
      text: 'Skip for now',
    },
    showHeader: false,
    ModalContent: () => <SuccessActivatedModalUi />,
    primaryAction: {
      onAction: () => {
        modalStore.removeModal(id)
        uiStore.changeRouteViaVue({
          path: `/${InboxesPath.root}`,
        })
      },
      text: 'Assign to inbox',
    },
    closeText: 'Skip for now',
  })
}
